import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import woman from "../files/woman.xlsx";
import stat from "../files/stat.pdf";
import "./macro.css"; // Предполагаю, что стили из macro.css подходят

const DocumentIcon = ({ type }) => (
  type === 'pdf' ? (
    <svg viewBox="0 0 24 24" fill="none" stroke="#2c5282" strokeWidth="2" aria-hidden="true">
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
      <path d="M14 2v6h6" />
      <path d="M16 13H8" />
      <path d="M16 17H8" />
      <path d="M10 9H8" />
    </svg>
  ) : (
    <svg viewBox="0 0 24 24" fill="none" stroke="#2c5282" strokeWidth="2" aria-hidden="true">
      <rect x="3" y="3" width="18" height="18" rx="2" />
      <path d="M3 9h18" />
      <path d="M9 3v18" />
    </svg>
  )
);

const DownloadLink = ({ href, icon, text, onClick }) => (
  <a
    href={href}
    className="download-link"
    onClick={onClick}
    aria-label={text}
  >
    <span className="download-link__icon">
      <DocumentIcon type={icon} />
    </span>
    {text}
  </a>
);

const BankStatistic = () => {
  const { t } = useTranslation();
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [pinCode, setPinCode] = useState('');
  const [error, setError] = useState('');
  const [selectedFile, setSelectedFile] = useState(''); // Для хранения выбранного файла
  const correctPin = '1234'; // Статический пин-код

  const handleDownloadClick = (e, file) => {
    e.preventDefault();
    setSelectedFile(file);
    setIsPopupOpen(true);
  };

  const handlePinSubmit = (e) => {
    e.preventDefault();
    if (pinCode === correctPin) {
      setError('');
      setIsPopupOpen(false);
      setPinCode('');
      const link = document.createElement('a');
      link.href = selectedFile;
      link.download = '';
      link.click();
    } else {
      setError(t('statistics.invalidPin'));
    }
  };

  const handleClosePopup = () => {
    setIsPopupOpen(false);
    setPinCode('');
    setError('');
    setSelectedFile('');
  };

  return (
    <div className="training-plan">
      <div className="training-item">
        <h2 className="training-item__title">{t('bankingSector.title')}</h2>
        <div className="training-item__content">
          <p>{t('bankingSector.description')}</p>
          <div className="stats-grid">
            <div className="stat-card">
              <div className="stat-card__label">{t('bankingSector.stats.banks.label')}</div>
              <div className="stat-card__value">{t('bankingSector.stats.banks.value')}</div>
            </div>
            <div className="stat-card">
              <div className="stat-card__label">{t('bankingSector.stats.microfinance.label')}</div>
              <div className="stat-card__value">{t('bankingSector.stats.microfinance.value')}</div>
            </div>
            <div className="stat-card">
              <div className="stat-card__label">{t('bankingSector.stats.insurance.label')}</div>
              <div className="stat-card__value">{t('bankingSector.stats.insurance.value')}</div>
            </div>
          </div>
          <p>{t('bankingSector.characteristics.title')}</p>
          <ul>
            {t('bankingSector.characteristics.items', { returnObjects: true }).map((item, index) => (
              <li key={`char-${index}`}>{item}</li>
            ))}
          </ul>
          <p>{t('bankingSector.development.title')}</p>
          <ul>
            {t('bankingSector.development.items', { returnObjects: true }).map((item, index) => (
              <li key={`dev-${index}`}>{item}</li>
            ))}
          </ul>
        </div>
      </div>

      <div className="training-item">
        <h2 className="training-item__title">{t('statistics.title')}</h2>
        <div className="training-item__content">
          <DownloadLink
            href={woman}
            icon="excel"
            text={t('statistics.downloads.stats2024')}
            onClick={(e) => handleDownloadClick(e, woman)}
          />
          <DownloadLink
            href={stat}
            icon="pdf"
            text={t('statistics.downloads.stats2023')}
            onClick={(e) => handleDownloadClick(e, stat)}
          />
        </div>
      </div>

      {isPopupOpen && (
        <div className="popup-overlay">
          <div className="popup">
            <h3>{t('statistics.popupTitle')}</h3>
            <form onSubmit={handlePinSubmit}>
              <label htmlFor="pinCode">{t('statistics.pinLabel')}</label>
              <input
                type="password"
                id="pinCode"
                value={pinCode}
                onChange={(e) => setPinCode(e.target.value)}
                placeholder={t('statistics.pinPlaceholder')}
                autoFocus
                aria-invalid={error ? 'true' : 'false'}
                aria-describedby={error ? 'pin-error' : undefined}
              />
              {error && (
                <p id="pin-error" className="error">
                  {error}
                </p>
              )}
              <div className="popup-actions">
                <button type="submit">{t('statistics.submitButton')}</button>
                <button type="button" onClick={handleClosePopup}>
                  {t('statistics.cancelButton')}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default React.memo(BankStatistic);